import { OrderStatusCounts } from '~/shared/api/services/orders/types'
import { Dates, Order, OrdersData } from '~/shared/api/services/delivery/types'
import {
  TicketMessageCreatedData,
  TicketUpdateNotificationData,
} from '~/shared/api/services/tickets/types'

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

const isOrder = (value: unknown): value is Order => {
  if (!isRecord(value)) {
    return false
  }

  return (
    typeof value.id === 'string' &&
    typeof value.number === 'string' &&
    (typeof value.systemNumber === 'string' || value.systemNumber === null) &&
    (typeof value.label === 'string' || value.label === null) &&
    (typeof value.badge === 'string' || typeof value.badge === 'number') &&
    typeof value.style === 'string' &&
    typeof value.express === 'boolean'
  )
}

const isDates = (value: unknown): value is Dates => {
  if (!isRecord(value)) {
    return false
  }

  return Object.values(value).every(
    (orders) => Array.isArray(orders) && orders.every(isOrder),
  )
}

export const isOrdersData = (value: unknown): value is OrdersData => {
  if (!isRecord(value) || !isRecord(value.ordersData)) {
    return false
  }

  return isDates(value.ordersData.dates)
}

export const isOrderStatusCounts = (
  value: unknown,
): value is OrderStatusCounts => {
  if (!isRecord(value)) {
    return false
  }

  return (
    typeof value.legalEntityId === 'string' &&
    typeof value.assembly === 'number' &&
    typeof value.dispatch === 'number' &&
    typeof value.express === 'number'
  )
}

export const isTicketUpdateNotificationData = (
  value: unknown,
): value is TicketUpdateNotificationData => {
  if (!isRecord(value)) {
    return false
  }

  return (
    typeof value.notificationId === 'string' &&
    typeof value.ticketId === 'string' &&
    (typeof value.ticketNumber === 'number' || value.ticketNumber === null) &&
    (value.type === 'message_added' || value.type === 'moved_to_in_progress') &&
    typeof value.hasUnreadUpdates === 'boolean'
  )
}

export const isTicketMessageCreatedData = (
  value: unknown,
): value is TicketMessageCreatedData => {
  if (!isRecord(value)) {
    return false
  }

  return typeof value.eventId === 'string' && typeof value.ticketId === 'string'
}
